import localDB from "./localDB";
let GLOBAL = require('./globals');

const auth = {
    login(email, password, res) {
        fetch(`${GLOBAL.BASE_URL}api/account/login`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email, password})
        }).then((response) => response).then(data =>{
            if(data.status !== 200){
                localDB.cleanSession();
                res(false)
            }else {
                data.json().then(response => {
                    localDB.initialData(response);
                    res(true)
                });
            }
        }).catch(() => {
            res(false);
        });
    },

    async registerStore(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/stores/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },

    async resetPassword(email, res) {
        await fetch(`${GLOBAL.BASE_URL}api/account/reset-password`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(email)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },

    async resetPasswordConfirm(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/account/reset-password-confirm`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseData) => {
                localDB.initialData(responseData);
                res(responseData)
            })
            .catch((err) => res(err));
    },

    logout: function (res) {
        fetch(`${GLOBAL.BASE_URL}api/account/logout`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: {}
        }).then((response) => {
            if (response.status === 204) {
                localDB.cleanSession();
                res(true);
            }else{
                res(false);
            }
        }).catch(() => {
            localDB.cleanSession();
            res(true);
        });
        localDB.cleanSession();
    },
    changePassword(new_password, re_new_password, current_password, res) {
        fetch(`${GLOBAL.BASE_URL}auth/password/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify({
                new_password: new_password,
                re_new_password: re_new_password,
                current_password: current_password
            })
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },

    async checkPermissionView(access) {
        const response = await fetch(`${GLOBAL.BASE_URL}api/account/check-permission-view?access=${access}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },

    async refresh() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/account/refresh`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify({
                token: localDB.getAuthToken(),
            })
        });
        return await response.json();
    },

    async checkVersion() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/account/check-version`);
        return await response.json();
    },

    async tokenUID() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/account/token-uid`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default auth;



// WEBPACK FOOTER //
// ./src/data/auth.js